import * as React from 'react'
import { SVGProps } from 'react'
const SvgTie = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 296.468 296.468" {...props}>
    <path d="M92.181 49.208a9.073 9.073 0 0 0 9.002 7.93h41.718a9.074 9.074 0 0 0 9.002-7.931l4.95-38.991A9.075 9.075 0 0 0 147.852 0H96.23a9.072 9.072 0 0 0-9.001 10.217zM215.921 215.03l-7.3-34.992a46.626 46.626 0 0 0-7.732-17.619l-31.428-43.886 6.178 86.399 30.232 17.384a6.803 6.803 0 0 0 10.05-7.286zM152.32 89.132a9.074 9.074 0 0 0-9.051-8.427h-42.454a9.075 9.075 0 0 0-9.051 8.427L80.559 245.847a25.235 25.235 0 0 0 7.478 20.878l28.07 27.327a8.485 8.485 0 0 0 5.938 2.415 8.482 8.482 0 0 0 5.937-2.415l28.066-27.327a25.238 25.238 0 0 0 7.479-20.878z" />
  </svg>
)
export default SvgTie
